import Axios from "axios";
import { AdminService_URL } from "../Url";
import { ROLES, warehouseId } from "../../constants/index";
import roleRedirect from "../../components/RoleRedirect/RoleRedirect";
import { message } from "antd";
import { removeTaskData } from "../../helper/toBinHelper";

export const AuthActions = {
  Login_Start: "Login_Start",
  Login_Failure: "Login_Failure",
  Toggle_SnackBar_Open: "Toggle_SnackBar_Open",
  Toggle_SnackBar_Close: "Toggle_SnackBar_Close",
  Logout_User: "Logout_User",
  loginSuccess: (data, userType) => (dispatch) => {
    dispatch({
      type: AuthActions.Login_Start,
      payload: data,
      userType: userType,
    });
  },
};

let loginSucces = (data, userType) => ({
  type: AuthActions.Login_Start,
  payload: data,
  userType: userType,
});

let userTypeSuccess = (data) => ({
  type: AuthActions.Login_Start,
  payload: data,
});

let loginFailure = (error) => ({
  type: AuthActions.Login_Failure,
  payload: error,
});

let ToggleSnackbarOpenAction = (error) => ({
  type: AuthActions.Toggle_SnackBar_Open,
  payload: error,
});

export let ToggleSnackbarCloseAction = () => ({
  type: AuthActions.Toggle_SnackBar_Close,
});

// Authentication
export const verifyUserAndPass = (props) => {
  removeTaskData();

  return async (dispatch) => {
    try {
      const response = await Axios({
        method: "POST",
        data: props,
        url: `${AdminService_URL}/admin/login?loginId=${props.loginId}`,
      });
      if (response.status === 200) {
        let path = roleRedirect(response.data?.userDTO);
        if (
          response.data?.userDTO?.warehouseIdList?.find(
            (e) => e === warehouseId
          )
        ) {
          if (path) {
            props.history.push(path);
          }
        } else {
          message.error("You don't have access to this portal");
        }

        localStorage.setItem("accessKey", response?.data?.data?.access_token);

        dispatch(
          AuthActions.loginSuccess(
            response.data,
            response.data.userDTO.warehouseIdList.length > 1 ? 1 : 0
          )
        );
      } else {
        const error = new Error(response.statusText);
        dispatch(loginFailure(error));
        dispatch(ToggleSnackbarOpenAction(error));
        throw error;
      }
    } catch (err) {
      if (err.response) {
        switch (err.response.status) {
          case 400:
            dispatch(
              loginFailure(
                err.response.data[400]
                  ? err.response.data[400]
                  : "Invalid Credentials"
              )
            );
            dispatch(
              ToggleSnackbarOpenAction(
                err.response.data[400]
                  ? err.response.data[400]
                  : "Invalid Credentials"
              )
            );
            break;
          case 404:
            dispatch(loginFailure("Unknown Error"));
            dispatch(ToggleSnackbarOpenAction("Unknown Error"));
            break;
          case 500:
            dispatch(loginFailure("Server Error"));
            dispatch(ToggleSnackbarOpenAction("Server Error"));
            break;
          default:
            dispatch(loginFailure("Unknown Error"));
            dispatch(ToggleSnackbarOpenAction("Unknown Error"));
            break;
        }
      } else {
        dispatch(loginFailure("Internal Server Error"));
        dispatch(ToggleSnackbarOpenAction("Unknown Error"));
      }
    }
  };
};

// Logout Action
export const LogoutUserAction = () => ({
  type: AuthActions.Logout_User,
});

export const LogoutUserThunk = (history) => {
  return (dispatch) => {
    dispatch(LogoutUserAction());
    localStorage.removeItem("accessKey");
    localStorage.setItem("pickerFlow", JSON.stringify(null));
    history.push("/");
  };
};
